import React, { useState, useRef } from 'react';
import axios from "axios";

//DB
var dbendpoint = process.env.REACT_APP_DB_API4;


function ToyBox() {
  const [elements, setElements] = useState([]);
  const inputRef = useRef();

  const handleAddElement = () => {
    const newElement = inputRef.current.value;
    setElements(prevElements => [...prevElements, newElement]);
    inputRef.current.value = 'Pending Item';
  };




	/*
	//Sorting of arrays by objects:
	//localstate.orderby:"SerialNumber" - Used in Item Pricing
	pricing.sort(function(a,b){
		//Numeric Values
		if (localstate.orderby==='Cost'){
			return a[localstate.orderby]-b[localstate.orderby];
		} else {
			//Alphabetic
			if (a[localstate.orderby] < b[localstate.orderby]){return -1;}
			if (a[localstate.orderby] > b[localstate.orderby]){return 1;}
			return 0;
		}
	});
	//Reverse if needed
	if (localstate.order==="desc"){
		pricing.reverse();
	}
	*/

	//Default Axios Post Options
	const defaultpostoptions = {
		withCredentials: true,
		withXSRFToken: true,
		crossDomain: true,
		mode: "no-cors",
		timeout: 11800,
	};


	const TestPost = () =>{
		//Sample postdata.
		const postdata = {
			item:"this"
		};
		axios.post(dbendpoint+"/emailcontroller/testpost", postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status===200){
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status==="login"){
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status==="Success"){
					console.log(res);
				}
				if (res.data.Status==="Failure"){
					//Failure error
					//dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "neutral" }));
					//dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				//dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				//dispatch(setErrorTimeout(15));
			}
		});
	}



  return (
    <div>
      <input type="text" ref={inputRef} />
      <button onClick={handleAddElement}>Add</button>
      <ul>
        {elements.map((element, index) => (
          <li key={index}>{element}</li>
        ))}
      </ul>
	  <button onClick={()=>TestPost()}>Test Post</button>
    </div>
  );
}

export default ToyBox;